import { render } from "./TournamentTableEditor.vue?vue&type=template&id=537c7e4e&scoped=true"
import script from "./TournamentTableEditor.vue?vue&type=script&lang=js"
export * from "./TournamentTableEditor.vue?vue&type=script&lang=js"

import "./TournamentTableEditor.vue?vue&type=style&index=0&id=537c7e4e&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537c7e4e"]])

export default __exports__